import { useTranslation } from "react-i18next";

export const OrSeparator = () => {
  const { t } = useTranslation();

  return (
    <div className="flex w-full flex-row">
      <hr className="w-full border-primary-25" />
      <span className="px-2 pt-px font-semibold text-primary-100">
        {t("portal:watchSim.watchSimOrWearable.or")}
      </span>
      <hr className="w-full border-primary-25" />
    </div>
  );
};
